import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import { generateSampleDetailsParams } from '@features/filter/static/filterUtil';

import { handleFilterOfListPage } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { isFashionDesigner } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

const SampleInlineComment = ({
	sampleRequestId,
	id,
	remarks,
	onReset,
	activeRemarksId,
	isSet = false,
	setmembers = [],
	cardType
}) => {
	const [message, setMessage] = useState('');
	const dispatch = useDispatch();
	const filterfields = useSelector((store) => store.filterFieldStore);
	const { id: sampleDetailsId } = useParams();
	const { ...paramsData } = generateSampleDetailsParams(filterfields);

	useEffect(() => {
		setMessage(remarks);
	}, [remarks]);

	const handleMessage = (e) => {
		setMessage(e.target.value);
	};

	const fetchSampleDetails = () => {
		if (cardType === 'DEVELOPMENT') {
			dispatch(
				handleFilterOfListPage(
					{ type: 'getProductsWithSampleItemByCollection', idUrl: `${sampleDetailsId}/products` },
					paramsData,
					false
				)
			);
		} else {
			dispatch(
				handleFilterOfListPage(
					{ type: 'sampleDetailsAction', idUrl: `${sampleDetailsId}` },
					paramsData,
					false
				)
			);
		}
	};

	const saveMessage = () => {
		dispatch(openLoader());
		const setmembersIds = setmembers.map((member) => member.id);
		let postData = {
			id: id,
			remarks: message,
			isSet: !!isSet,
			setMemberIdList: isSet ? setmembersIds : []
		};
		ApiClient.PUT(`${BASE_URL}/sample/request/${sampleRequestId}/items`, postData, '', true)
			.then(() => {
				fetchSampleDetails();
				dispatch(closeLoader());
				if (onReset) {
					onReset(postData);
				}
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	return (
		<p className="regular-14 gray_dark_01" key={`inline_comment_${id}`}>
			{activeRemarksId !== id ? (
				<span>{message}</span>
			) : (
				<input
					type="text"
					autoComplete="off"
					placeholder="Comment here"
					value={message}
					onChange={handleMessage}
					autoFocus={true}
					onBlur={saveMessage}
					onKeyPress={(e) => {
						if (e.key === 'Enter') {
							saveMessage();
						}
					}}
					disabled={cardType === 'DEVELOPMENT' && !isFashionDesigner()}
				/>
			)}
		</p>
	);
};

export default SampleInlineComment;
